import PropTypes from 'prop-types';
// import { defineMessages, useIntl } from 'react-intl';
import { ConditionalLink, Image } from '@plone/volto/components';
import type { BlockViewProps, RelatedItem } from '@plone/types';
import { Tags } from '../../Tag/Tags';
import { H3, Text } from '../../Typography';
import EventDate from '../../../helpers/EventDate';
// import { SimpleBreadCrumbs } from '../../../customizations/components/theme/Breadcrumbs/Breadcrumbs';

// Define translatable messages
// const messages = defineMessages({
//   located_in: {
//     id: 'Located in',
//     defaultMessage: 'Located in:',
//   },
// });

type ListingItem = RelatedItem & { tags: string[]; end: string; start: string };
type Props = BlockViewProps & {
  '@type': string;
  item: ListingItem;
  blocks_layout: { items: any[] };
  styles?: { gridCutoff: 2 | 3 | 4 };
  isEditMode: boolean;
};

const EventsItem = ({ item, isEditMode }: Props) => {
  // const intl = useIntl();
  return (
    <div className="listing-item listing-item--event" key={item['@id']}>
      <ConditionalLink to={null} item={item} condition={!isEditMode}>
        <div className="listing-body">
          <Image
            item={item}
            imageField={item.image_field}
            alt=""
            loading="lazy"
            responsive={true}
          />
          <div className="listing-body__content">
            <Text className="listing-body__date">
              <EventDate start={item.start} end={item.end} />
            </Text>
            <H3>{item.title ? item.title : item['@id']}</H3>
            <Text>{item.description}</Text>
            <Tags tags={item.tags} />
            {/* {item.breadcrumbs.length > 0 ? (
              <Text>
                {intl.formatMessage(messages.located_in)}{' '}
                <SimpleBreadCrumbs item={item} isEditMode={isEditMode} />
              </Text>
            ) : (
              ''
            )} */}
          </div>
        </div>
      </ConditionalLink>
    </div>
  );
};
EventsItem.propTypes = {
  item: PropTypes.any.isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};
export default EventsItem;
